import {canonicalShopModel} from './shopVehicleCompatibility';
/** Catalogue family only, never inferred from a nickname, VIN or registration. */
export function vehicleShopModel(vehicle?:{name?:string}):string{
 return canonicalShopModel(vehicle?.name||'');
}
export function vehicleShopUrl(language:string,store:string,vehicle?:{name?:string},theme:'light'|'dark'='light'){
 const q=new URLSearchParams({lang:language}),model=vehicleShopModel(vehicle);
 if(theme==='dark')q.set('theme','dark');
 if(store!=='retail'){q.set('store',store);q.set('browse','1');}
 if(model){q.set('model',model);q.set('browse','1');}
 const base=location.pathname.includes('/demo/precision-ev/')?'/demo/precision-ev/shop-ui/':'/shop-ui/';
 return base+'?'+q;
}
